module.exports = __webpack_public_path__ + "img/bg-7.375c0822.jpg";